import { render, staticRenderFns } from "./Empaques.vue?vue&type=template&id=55531d24&scoped=true"
import script from "./Empaques.vue?vue&type=script&lang=js"
export * from "./Empaques.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Empaques.vue?vue&type=style&index=1&id=55531d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55531d24",
  null
  
)

export default component.exports